import baseUrl from '../../utils/baseUrl';

export async function loginWithCode(email: string, verificationCode: string) {
  return fetch(`${baseUrl()}/auth/login_with_verification_code`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      email: email,
      verification_code: verificationCode
    })
  }).then((data) => data.json());
}